

//import these files so webpack processes them
import "../config/$env";


const common = {
	...window.REDI_enviromentConfig,
	apiPrefix: "api/",
	get baseUrl() {
		return window.REDI_enviromentConfig.siteBaseUrl + this.apiPrefix;
	},
	tokenKey: "token-key",
	tokenExpDateKey: "tokenExpDateKey",
};

export default common;


// WEBPACK FOOTER //
// ./src/boot/config.js